<template>
  <div class="countdown-line" :class="{'countdown-line--gifts-for-mans': giftsForMans}">
    <div v-if="!giftsForMans" class="countdown-line__users">
      <span class="countdown-line__users-number">{{ usersOnline }}</span>
      <span class="countdown-line__users-text" v-html="usersTranslation"></span>
    </div>
    <div v-if="!giftsForMans" class="countdown-line__middle">
      <p class="countdown-line__middle-text">
        <slot name="middle-text"></slot>
      </p>
      <img class="countdown-line__middle-img" src="/img/mario-50-percents.png" alt="mario">
    </div>
    <template v-else>
      <p class="countdown-line__middle-text">
        <slot name="middle-text"></slot>
      </p>
      <img class="countdown-line__middle-img" src="https://static.dnipro-m.ua/origin/custom-sale/ny-gifts.png?_t=1639056306" alt="gift">
    </template>
    <div class="countdown-line__timer-wrap">
      <timer v-if="deadline"
             class="countdown-line__timer"
             :deadline="deadline"
             type="light"
             :title="timerTitle"
             is-product-page></timer>
      <slot v-else></slot>
    </div>
    <div v-if="giftsForMans" class="countdown-line__bottom">
      <img src="https://static.dnipro-m.ua/origin/custom-sale/ny-gifts.png?_t=1639056306" alt="gift">
    </div>
  </div>
</template>

<script>
import Timer from '@/components/promo-pages/Timer'
import CurrencyFormatter from '@/filters/CurrencyFormatter'
import { wordFormatter } from '@/mixins/wordFormatter'
export default {
  name: 'CountdownLine',
  mixins: [wordFormatter],
  filters: {
    CurrencyFormatter
  },
  components: { Timer },
  props: {
    deadline: {
      type: String,
      required: true
    },
    timerTitle: {
      type: String,
      default: ''
    },
    giftsForMans: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    usersOnline () {
      return window.config.total_users_online
    },
    usersTranslation () {
      return this.wordFormatter(this.usersOnline, [this.$t('bf_page_stats_1'), this.$t('bf_page_stats_2'), this.$t('bf_page_stats_3')])
    }
  }
}
</script>

<style scoped lang="sass">
.countdown-line
  position: relative
  background-image: url('/img/blue-bg-snow.jpg')
  background-size: cover
  border-radius: 10px
  padding: 25px

  display: flex
  flex-flow: column

  &::before
    content: ''
    left: 0
    top: 0
    bottom: 5%
    width: 100%
    background-image: url('/img/mario-50-percents_mobile.png')
    background-position: top right
    background-repeat: no-repeat
    background-size: auto 95%
    position: absolute

  &::after
    content: ''
    position: absolute
    bottom: 0
    left: 0
    height: 60%
    background-image: linear-gradient(180.44deg, rgba(224, 238, 255, 0) 0.39%, rgba(229, 240, 254, 0.593799) 16.12%, rgba(232, 242, 253, 0.89) 25.83%, #EDF3FB 52.43%, #F8F8F8 119.94%)
    z-index: 1
    width: 100%

  +mmin($tablet)
    background-image: url('/img/blue-gradient.jpg')
    padding: 0 30px
    flex-flow: row nowrap
    justify-content: space-around
    align-items: center
    &::before, &::after
      display: none

.countdown-line__timer
  width: auto
  align-items: center

.countdown-line__timer-wrap
  position: relative
  z-index: 2

.countdown-line__users
  width: 100%
  display: flex
  justify-content: center
  align-items: center
  margin-bottom: 25px

  +mmin($tablet)
    width: 20%
    margin-bottom: 0
    margin-right: 20px

  +mmax(1100)
    display: none

.countdown-line__users-number
  color: #343A44
  font-size: 36px
  white-space: nowrap

  +mmin($tablet)
    font-size: 44px

.countdown-line__users-text
  color: #343A44
  font-size: 14px
  margin-left: 15px
  font-weight: 500

  +mmin($tablet)
    margin-left: 20px

.countdown-line__middle
  display: flex
  align-items: center
  margin-bottom: 25px
  position: relative
  z-index: 2
  +mmin($tablet)
    margin-bottom: 0

.countdown-line__middle-text
  margin: 0
  max-width: 230px
  font-size: 24px
  text-transform: uppercase
  color: #343A44
  font-weight: bold
  +mmin($tablet)
    font-size: 28px
  +mmin($large)
    font-size: 36px

.countdown-line__middle-img
  display: none
  +mmin($tablet)
    display: inline

::v-deep .timer__title
  font-weight: 500!important

.countdown-line--gifts-for-mans
  background-image: url('/img/blue-gradient.jpg')
  +mmax($tablet - 1)
    padding-bottom: 0
  &::after, &::before
    display: none
  .countdown-line__middle-text
    max-width: unset
    padding: 10px 0
    text-align: center
    +mmin($tablet)
      text-align: left
  .countdown-line__middle-img
    align-self: flex-end
    margin: 0 15px
  .countdown-line__bottom
    text-align: center
    font-size: 0
    margin-top: 15px
    +mmin($tablet)
      display: none
</style>
